import { useEffect } from "react";
import { AuthService } from "@/services/auth.service";
import { ConfigurationService } from "@/services/configuration.service";

const ChatBot = () => {
  const configurationData = ConfigurationService.configuration;
  const websiteId = configurationData?.config?.chatbot?.websiteId;
  if (!websiteId) return null;

  useEffect(() => {
    if (typeof window !== "undefined") {
      (window as any).$crisp = [];
      (window as any).CRISP_WEBSITE_ID = websiteId;

      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [websiteId]);

  useEffect(() => {
    const initializeCrispUser = async () => {
      try {
        if (typeof window !== "undefined" && (window as any).$crisp) {
          const userProfile = await AuthService.getUserProfile();
          const reporter_email = userProfile?.email;
          const reporter_name = userProfile?.firstName;

          if (reporter_name) {
            (window as any).$crisp.push([
              "set",
              "user:nickname",
              [reporter_name],
            ]);
          }
          if (reporter_email) {
            (window as any).$crisp.push([
              "set",
              "user:email",
              [reporter_email],
            ]);
          }
        }
      } catch (error) {
        console.error("Authentication or Crisp initialization error:", error);
      }
    };

    initializeCrispUser();
  }, []);

  return null;
};

export default ChatBot;
